import type {IFilterService} from 'angular';
import type {SvelteContext} from '../types';
import type {LogService} from '../logging/log.service';
import {AngularManualInjector} from '../injector';
import {
    createDateFormatterFunction,
    createLocalizationFunction,
    createSanitizeHtmlFunction,
    CURRENT_LANGUAGE_KEY,
    DATE_FORMATTER_KEY,
    GLOBAL_EVENT_BUS_KEY,
    INJECTOR_KEY,
    LOCALIZE_KEY,
    LOGGER_KEY,
    SANITIZE_HTML_KEY,
    SERVER_URL_KEY
} from '../utils';

/*@ngInject*/
export function defaultContextFactory($injector: angular.auto.IInjectorService,
                                      $filter: IFilterService,
                                      logService: LogService,
                                      SERVER_URL: string,
                                      GLOBAL_EVENT_BUS: EventTarget,
                                      currentLanguage: string): SvelteContext {

    const svelteContext = new Map<string, any>();
    const injector = new AngularManualInjector($injector);

    svelteContext.set(INJECTOR_KEY, injector);
    svelteContext.set(LOCALIZE_KEY, createLocalizationFunction(injector));
    svelteContext.set(SANITIZE_HTML_KEY, createSanitizeHtmlFunction(injector));
    svelteContext.set(DATE_FORMATTER_KEY, createDateFormatterFunction($filter('jpDate')));
    svelteContext.set(LOGGER_KEY, logService);
    svelteContext.set(CURRENT_LANGUAGE_KEY, currentLanguage);
    svelteContext.set(SERVER_URL_KEY, SERVER_URL);
    svelteContext.set(GLOBAL_EVENT_BUS_KEY, GLOBAL_EVENT_BUS);

    return svelteContext;
}

defaultContextFactory.factoryName = 'svelteDefaultContext';
